export default __webpack_public_path__ + "static/media/nossas_unidades_11.759c6e61.webp";